import { ZCDHorizontalBarChart } from '@zencity/common-ui';
import { ZCDHorizontalBarChartJSOptions } from '@zencity/common-ui/lib/ZCD/ZCDCharts/ZCDHorizontalBarChart/ZCDHorizontalBarChart';
import React, { ReactElement, useContext } from 'react';
import {
  DivisionColor,
  groupDataItemsEvenly,
  reduceDivisionScoresToDataItems,
} from 'screens/WidgetGenerator/reportGeneratorComponents/components/ScoresOverTimeByArea/ScoresList/ScoreRow/DivisionAspectScoresBarChart/DivisionAspectScoresBarChart.helpers';
import { Flex } from 'components/Flex/Flex';
import { useTranslation } from 'react-i18next';
import { ScoreOverTimeByAreaContext } from 'contexts/ScoresOverTimeByAreaContext';
import styles from './DivisionAspectScoresBarChart.module.scss';

const DEFAULT_BACKGROUND_COLOR: DivisionColor = 'ZCD_DATA_BLUE_10';

export const DivisionAspectScoresBarChart = (): ReactElement => {
  const { t: translate } = useTranslation();
  const { selectedAspectScore, selectedDateRange, allAspectScores } = useContext(ScoreOverTimeByAreaContext);
  const { divisions: divisionScores } = selectedAspectScore;

  const horizontalBarChartDataItems = reduceDivisionScoresToDataItems({
    divisionScores,
    selectedDateRange,
    allAspectScores,
    selectedAspectScore,
  });

  const options = {
    barThickness: 8,
    // Disable all interactive events.
    events: [],
  } as ZCDHorizontalBarChartJSOptions;

  const threshold = selectedAspectScore.overall.score;
  const groupedDataItems = groupDataItemsEvenly(horizontalBarChartDataItems);
  return (
    <div>
      <p>{translate('widgetGenerator.widgets.scoresOverTimeByArea.barChart.title')}</p>
      <Flex gap="16px">
        {groupedDataItems.map((dataItems) => (
          <div key={JSON.stringify(dataItems)} className={styles.container}>
            <ZCDHorizontalBarChart
              chartDatasets={[
                {
                  // eslint-disable-next-line id-denylist
                  data: dataItems,
                  backgroundColor: DEFAULT_BACKGROUND_COLOR,
                },
              ]}
              chartOptions={options}
              threshold={threshold}
              usePercentage={false}
              labelPadding={0}
            />
          </div>
        ))}
      </Flex>
    </div>
  );
};
